import React, { useEffect, useState } from "react";
import Card from "components/card";
import Button from "components/button";
import { getEvents, deleteEvent } from "services/events";
import { useNavigate } from "react-router-dom";

const Events = () => {
  const [events, setEvents] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await getEvents();
        setEvents(Array.isArray(data?.data) ? data?.data : []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleDelete = async (id: number) => {
    if (!window.confirm("Are you sure you want to delete this event?")) return;
    try {
      await deleteEvent(id);
      setEvents((prev) => prev.filter((e) => e.id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Card extra="w-full p-4">
      <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-2xl font-bold text-gray-900">Events</h2>
        <div className="mt-3 sm:mt-0">
          <Button as="link" to="/admin/events/create">
            Create Event
          </Button>
        </div>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : events.length === 0 ? (
        <p className="text-gray-500">No events yet.</p>
      ) : (
        <div className="space-y-4">
          {events.map((event) => (
            <div
              key={event.id}
              className="rounded bg-white p-4 shadow-sm dark:bg-navy-700"
            >
              <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                <div>
                  <h3 className="text-lg font-semibold">{event.name}</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-300">
                    {event.description}
                  </p>
                </div>
                <div className="mt-3 flex items-center space-x-2 md:mt-0">
                  <div className="mr-2 hidden items-center gap-3 text-sm text-gray-600 sm:flex">
                    <div className="text-green-600">
                      Going:{" "}
                      <strong className="text-gray-900">
                        {event.going_count || 0}
                      </strong>
                    </div>
                    <div className="text-yellow-600">
                      Maybe:{" "}
                      <strong className="text-gray-900">
                        {event.maybe_count || 0}
                      </strong>
                    </div>
                  </div>
                  <Button
                    size="sm"
                    variant="outline"
                    as="link"
                    to={`/admin/events/${event.id}/attendance`}
                  >
                    Attendance
                  </Button>
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => navigate(`/admin/events/${event.id}/edit`)}
                  >
                    Edit
                  </Button>
                  <Button
                    size="sm"
                    variant="danger"
                    onClick={() => handleDelete(event.id)}
                  >
                    Delete
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};

export default Events;
